import React, { useMemo } from "react";
import CustomCard from "../Card";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../molecules/ReactEchart";

const RecurrentCard: React.FC = React.memo(() => {
  const options: EChartsOption = useMemo(
    () => ({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params: any) => {
          const { value } = params[0];
          return `${value}K`;
        },
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "10%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: [
          "Air Conditioning",
          "Carpentry",
          "Electrical",
          "Masonry",
          "Painting",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          fontSize: 12,
          color: "#1F5782",
          rotate: 20,
        },
      },
      yAxis: {
        type: "value",
        splitLine: { show: false },
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          show: false,
        },
      },
      series: [
        {
          type: "bar",
          data: [2.5, 3.5, 5.2, 4.5, 3.8],
          barWidth: "40%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0],
            color: ({ dataIndex }) => (dataIndex === 3 ? "#0E3D5D" : "#1F5782"),
          },
          label: {
            show: false,
            position: "top",
            fontSize: 14,
            fontWeight: "bold",
            formatter: ({ value }) => `${value}K`,
            color: "#1F5782",
          },
        },
      ],
    }),
    []
  );

  return (
    <CustomCard heading="RECURRENT" subHeading="CASE / CATEGORY">
      <ReactEchart
        options={options}
        style={{ height: "400px", width: "100%" }}
      />
    </CustomCard>
  );
});

export default RecurrentCard;
